import * as React from "react"

import { cn } from "@/lib/cn"

const Input = React.forwardRef<HTMLInputElement, React.ComponentProps<"input">>(
  ({ className, type, ...props }, ref) => {
    return (
      <input
        type={type}
        className={cn(
          // Patched: 44px floor, card surface, hairline border. `border-input` is NOT used
          // because `input` is already this app's SURFACE token (bg-input) — shadcn's
          // default would have drawn a white border on a white field.
          "flex min-h-[44px] w-full rounded-md border border-hairline-strong bg-card px-3 py-1 text-base transition-[border-color,box-shadow] duration-150 motion-reduce:transition-none file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-ink-faint focus-visible:outline-hidden focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-offset-background disabled:cursor-not-allowed disabled:opacity-60 md:text-sm",
          className
        )}
        ref={ref}
        {...props}
      />
    )
  }
)
Input.displayName = "Input"

export { Input }
